import { apiFetch } from './apiFetch';

const API_BASE = process.env.REACT_APP_API_URL;

export async function fetchDashboard() {
  const res = await apiFetch(`${API_BASE}/admin/dashboard`);
  return res.json();
}
